"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Wire = void 0;
const Point_1 = require("./Point");
class Wire {
    static createFromEagle(w, parent) {
        const wire = new Wire();
        wire.layer = parseInt(w._attributes.layer);
        wire.width = parseFloat(w._attributes.width);
        let p1 = new Point_1.Point(w._attributes.x1, w._attributes.y1);
        let p2 = new Point_1.Point(w._attributes.x2, w._attributes.y2);
        if (parent) {
            p1 = p1.rotate(parent.rotation);
            p2 = p2.rotate(parent.rotation);
            if (parent.mirrored) {
                p1.x = -p1.x;
                p2.x = -p2.x;
            }
            p1.add(parent.point);
            p2.add(parent.point);
        }
        wire.vertices = [p1, p2];
        return wire;
    }
    combine(w) {
        return false;
        const thisFirst = this.vertices[0];
        const thisLast = this.vertices[this.vertices.length - 1];
        const otherFirst = w.vertices[0];
        const otherLast = w.vertices[1];
        if (w.layer != this.layer) {
            return false;
        }
        if (thisLast.x === otherFirst.x && thisLast.y === otherFirst.y) {
            this.vertices.push(w.vertices[1]);
            return true;
        }
        if (otherLast.x === thisFirst.x && otherLast.y === thisFirst.y) {
            this.vertices = [w.vertices[0]].concat(this.vertices);
            return true;
        }
        if (thisLast.x !== otherFirst.x || thisLast.y !== otherFirst.y) {
            return false;
        }
        this.vertices.push(w.vertices[1]);
        return true;
    }
}
exports.Wire = Wire;
//# sourceMappingURL=Wire.js.map